import React, { useState, useEffect } from "react";
import { withScriptjs, withGoogleMap, GoogleMap, Marker, Circle } from "react-google-maps";

const BrokerMap = withScriptjs(withGoogleMap((props) => {
  const [mapCenter, setMapCenter] = useState({
    lat: parseFloat(props.lat),
    lng: parseFloat(props.lng),
  });

  const [radius, setRadius] = useState((props.radius ? parseFloat(props.radius) : 50) * 1000);
  const [zoom, setZoom] = useState(8);

  // Function to determine zoom level based on radius
  const getZoomLevel = (radius) => {
    switch (radius) {
        case 5: return 11.8;
        case 10: return 10.8;
        case 15: return 10.2;
        case 20: return 9.8;
        case 25: return 9.5;
        case 50: return 8.5;
        case 75: return 8;
        default: return 8; // Default zoom if radius is undefined
    }
  };

  // Update center dynamically when lat/lng props change
  useEffect(() => {
    setMapCenter({
      lat: parseFloat(props.lat),
      lng: parseFloat(props.lng),
    });
  }, [props.lat, props.lng]);

  // Update radius and zoom dynamically when props.radius changes
  useEffect(() => {
    const parsedRadius = props.radius ? parseFloat(props.radius) : 50;
    setRadius(parsedRadius * 1000);
    setZoom(getZoomLevel(parsedRadius));
  }, [props.radius]);

  return (
    <GoogleMap zoom={zoom} center={mapCenter}>
      <Marker position={mapCenter} />
      <Circle 
        options={{
          strokeColor:'#0ab5dd',
          strokeOpacity:1,
          strokeWeight:0,
          fillColor:'#0ab5dd',
          fillOpacity:0.35
        }}
        center={mapCenter}
        radius={radius} // Now updates dynamically
      />
    </GoogleMap>
  );
}));

export default BrokerMap;
